import { defineMessages } from 'react-intl';

export default defineMessages({
  headTitle: {
    id: 'send.verification.email.head.title',
    defaultMessage: 'We need to verify your email',
    description:
      'Title of the interstitial page that prompts the user to send themselves a verification code email',
  },
  body: {
    id: 'send.verification.email.body',
    defaultMessage:
      'We just need to verify your email before we send you on your way. Please click the button below and check your email inbox.',
    description:
      'Text explaining that the user needs to verify their email and should click the button to receive a verification code',
  },
  sendButton: {
    id: 'send.verification.email.submit',
    defaultMessage: 'Send verification code email',
    description:
      'Text used for the button that sends the verification code email to the user so they can continue',
  },
  errorRateLimited: {
    id: 'send.verification.email.error-message.rate-limited',
    defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.',
    description: 'Error message returned when rate limited due to too many requests',
  },
  errorInternalServerError: {
    id: 'send.verification.email.error-message.internal-server-error',
    defaultMessage: 'Internal server error',
    description: 'Error message returned when the server fails to send the verification code email',
  },
  errorUnexpected: {
    id: 'send.verification.email.error-message.unexpected',
    defaultMessage: 'Unexpected error',
    description: 'Error message returned when there is an unexpected error',
  },
});
